import { VehicleDocumentSettings } from 'constants/vehicle/vehicleDocument';
import { Action } from 'redux';

export const GET_VEHICLE_DOCUMENT_SETTINGS = 'GET_VEHICLE_DOCUMENT_SETTINGS';
export interface GetVehicleDocumentSettingsAction extends Action<typeof GET_VEHICLE_DOCUMENT_SETTINGS> {
  readonly payload: { readonly groupName: string };
}
export const getVehicleDocumentSettings = (groupName: string): GetVehicleDocumentSettingsAction => ({
  payload: { groupName },
  type: GET_VEHICLE_DOCUMENT_SETTINGS,
});

export const PERSIST_VEHICLE_DOCUMENT_SETTINGS = 'PERSIST_VEHICLE_DOCUMENT_SETTINGS';
export interface PersistVehicleDocumentSettingsAction extends Action<typeof PERSIST_VEHICLE_DOCUMENT_SETTINGS> {
  readonly payload: ReadonlyArray<VehicleDocumentSettings>;
}
export const persistVehicleDocumentSettings = (
  settings: ReadonlyArray<VehicleDocumentSettings>,
): PersistVehicleDocumentSettingsAction => ({
  payload: settings,
  type: PERSIST_VEHICLE_DOCUMENT_SETTINGS,
});

export const UPDATE_VEHICLE_DOCUMENT_SETTINGS = 'UPDATE_VEHICLE_DOCUMENT_SETTINGS';
export interface UpdateVehicleDocumentSettingsAction extends Action<typeof UPDATE_VEHICLE_DOCUMENT_SETTINGS> {
  readonly payload: { readonly groupName: string; readonly settings: VehicleDocumentSettings };
}
export const updateVehicleDocumentSettings = (
  groupName: string,
  settings: VehicleDocumentSettings,
): UpdateVehicleDocumentSettingsAction => ({
  payload: { groupName, settings },
  type: UPDATE_VEHICLE_DOCUMENT_SETTINGS,
});
